import {InjectionToken} from "@angular/core";

export const INT_PORTAL_OUTLET_TOKEN = new InjectionToken('int portal outlet token');
